
import 'vue-awesome/icons/arrow-left'
import 'vue-awesome/icons/arrow-right'
import 'vue-awesome/icons/arrow-up'

export default
  metaInfo:
    title: "HoneyMoney Keyboard Shortcuts" #70 characters
    meta: [
      { name: 'description', content: "HoneyMoney Keyboard Shortcuts" }
    ]
